/**
 * 统一的本地存储工具类，处理web端和小程序端的存储兼容性
 */
class StorageUtil {
  /**
   * 存储数据到本地
   * @param key 存储键名
   * @param value 存储值
   * @param expiry 过期时间(毫秒)，可选
   */
  static setItem(key: string, value: any, expiry?: number): boolean {
    try {
      const data = {
        value,
        expiry: expiry ? Date.now() + expiry : null
      };

      // 使用uni-app的统一存储API
      uni.setStorageSync(key, JSON.stringify(data));
      return true;
    } catch (error) {
      console.error('存储失败:', error);
      return false;
    }
  }

  /**
   * 从本地获取数据
   * @param key 存储键名
   * @returns 存储值或null(过期或不存在)
   */
  static getItem(key: string): any {
    try {
      const dataStr = uni.getStorageSync(key);
      
      if (!dataStr) return null;
      
      const data = JSON.parse(dataStr);
      // 检查是否过期
      if (data.expiry && Date.now() > data.expiry) {
        // 过期数据自动清理
        this.removeItem(key);
        console.log('getItem', key, dataStr, '过期');

        return null;
      }
      console.log('getItem', key, data.value, '未过期');

      return data;
    } catch (error) {
      console.error('获取存储失败:', error);
      return null;
    }
  }

  /**
   * 从本地移除数据
   * @param key 存储键名
   */
  static removeItem(key: string): boolean {
    try {
      uni.removeStorageSync(key);
      return true;
    } catch (error) {
      console.error('删除存储失败:', error);
      return false;
    }
  }

  /**
   * 清空所有存储数据
   */
  static clear(): boolean {
    try {
      uni.clearStorageSync();
      return true;
    } catch (error) {
      console.error('清空存储失败:', error);
      return false;
    }
  }

  /**
   * 获取所有存储的键名
   * @returns 键名数组
   */
  static getAllKeys(): string[] {
    try {
      return uni.getStorageInfoSync().keys || [];
    } catch (error) {
      console.error('获取存储键名失败:', error);
      return [];
    }
  }
}

export default StorageUtil;